import Head from 'expo-router/head';
import { useIsFocused } from 'expo-router/react-navigation';

export function HeadWhenOnPage({ children }: { children?: React.ReactNode }) {
    const isFocused = useIsFocused();
    if (!isFocused) return null;
    if (!children) return null;

    return <Head>{children}</Head>;
}
